import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router'

const FullPrice = lazy(() => import('pages/platform/buy/FullPrice'))
const Regiment = lazy(() => import('pages/platform/buy/Regiment'))
const Payment = lazy(() => import('pages/platform/buy/Payment'))
const RegimentJoin = lazy(() => import('pages/platform/buy/RegimentJoin'))
const RegimentType = lazy(() => import('pages/platform/buy/RegimentType'))


const ActivityRoute = ({ match }) => {
  const rootUrl = match.url
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route exact path={`${rootUrl}/fullPrice`} component={(FullPrice)} />
        <Route exact path={`${rootUrl}/regiment`} component={(Regiment)} />
        <Route exact path={`${rootUrl}/payment`} component={(Payment)} />
        <Route exact path={`${rootUrl}/regimentJoin`} component={(RegimentJoin)} />
        <Route exact path={`${rootUrl}/regimentType`} component={(RegimentType)} />
      </Switch>
    </Suspense>
  )
}
export default ActivityRoute
